import { Input } from './ui/input';
import { Label } from './ui/label';
import { Switch } from './ui/switch';

export const HOURS_DAYS = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
];

export function defaultOperatingHoursState() {
  return HOURS_DAYS.reduce((acc, day) => {
    acc[day] = {
      active: !['saturday', 'sunday'].includes(day),
      open: '10:00',
      close: '18:00',
    };
    return acc;
  }, {});
}

/** Convert truck.operating_hours (API shape) into editor state. */
export function hoursStateFromTruck(operatingHours = {}) {
  return HOURS_DAYS.reduce((acc, day) => {
    const cfg = operatingHours[day];
    if (cfg && cfg.open && cfg.close) {
      acc[day] = { active: true, open: cfg.open, close: cfg.close };
    } else {
      acc[day] = { active: false, open: '10:00', close: '18:00' };
    }
    return acc;
  }, {});
}

/** Convert editor state into API operating_hours (only active days). */
export function truckHoursFromState(hoursState) {
  const out = {};
  Object.entries(hoursState).forEach(([day, cfg]) => {
    if (cfg.active) {
      out[day] = { open: cfg.open, close: cfg.close };
    }
  });
  return out;
}

export default function OperatingHoursEditor({
  hours,
  onChange,
  maxOrdersPerSlot,
  onMaxOrdersChange,
  showCapacity = true,
}) {
  return (
    <div className="space-y-4">
      <div className="space-y-3">
        {HOURS_DAYS.map((day) => (
          <div key={day} className="flex items-center gap-4 p-3 bg-card rounded-lg border">
            <Switch
              checked={hours[day].active}
              onCheckedChange={(checked) =>
                onChange({
                  ...hours,
                  [day]: { ...hours[day], active: checked },
                })
              }
              data-testid={`day-toggle-${day}`}
            />
            <span className="w-24 capitalize font-medium">{day}</span>
            {hours[day].active ? (
              <div className="flex items-center gap-2 flex-1">
                <Input
                  type="time"
                  value={hours[day].open}
                  onChange={(e) =>
                    onChange({
                      ...hours,
                      [day]: { ...hours[day], open: e.target.value },
                    })
                  }
                  className="w-auto"
                />
                <span className="text-muted-foreground text-sm">to</span>
                <Input
                  type="time"
                  value={hours[day].close}
                  onChange={(e) =>
                    onChange({
                      ...hours,
                      [day]: { ...hours[day], close: e.target.value },
                    })
                  }
                  className="w-auto"
                />
              </div>
            ) : (
              <span className="text-sm text-muted-foreground">Closed</span>
            )}
          </div>
        ))}
      </div>

      {showCapacity && onMaxOrdersChange ? (
        <div className="bg-card rounded-lg border p-4">
          <Label htmlFor="maxOrders">Max Orders Per Pickup Slot</Label>
          <p className="text-sm text-muted-foreground mb-3">
            Caps how many students can book the same pickup window
          </p>
          <select
            id="maxOrders"
            value={maxOrdersPerSlot}
            onChange={(e) => onMaxOrdersChange(parseInt(e.target.value, 10))}
            className="w-full p-3 rounded-lg bg-muted border-0 text-sm"
            data-testid="max-orders"
          >
            {[3, 5, 10, 15, 20].map((n) => (
              <option key={n} value={n}>
                {n} orders per slot
              </option>
            ))}
          </select>
        </div>
      ) : null}
    </div>
  );
}
